import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { MathNodeView } from './math-node-view';
export var MathExtension = Node.create({
  name: 'math',
  group: 'inline',
  inline: true,
  atom: true,
  // Thêm selectable để đảm bảo node có thể được chọn
  selectable: true,
  // Tắt tính năng draggable để tránh mất focus khi click và kéo
  draggable: false,
  addAttributes: function addAttributes() {
    return {
      latex: {
        "default": ''
      }
    };
  },
  parseHTML: function parseHTML() {
    return [{
      tag: 'math-inline'
    }];
  },
  renderHTML: function renderHTML(_ref) {
    var HTMLAttributes = _ref.HTMLAttributes;
    return ['math-inline', mergeAttributes(HTMLAttributes)];
  },
  addNodeView: function addNodeView() {
    return ReactNodeViewRenderer(MathNodeView, {
      // Thêm tùy chọn để ngăn chặn sự kiện click lan tỏa lên đến editor
      stopEvent: function stopEvent(props) {
        var event = props.event; // Ngăn chặn tất cả các sự kiện chuột từ việc lan tỏa

        if (event.type.startsWith('mouse') || event.type.startsWith('click') || event.type === 'focus' || event.type === 'blur') {
          return true;
        }

        return false;
      }
    });
  },
  addCommands: function addCommands() {
    var _this = this;

    return {
      insertMath: function insertMath() {
        return function (_ref2) {
          var commands = _ref2.commands;
          return commands.insertContent({
            type: _this.name,
            attrs: {
              latex: ''
            }
          });
        };
      }
    };
  }
});